var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 24,
    height: 24,
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M273.066667 392.533333h8.533333c32.853333 0 59.733333 26.88 59.733333 59.733334v298.666666c0 32.853333-26.88 59.733333-59.733333 59.733334h-8.533333c-32.853333 0-59.733333-26.88-59.733334-59.733334v-298.666666c0-32.853333 26.88-59.733333 59.733334-59.733334zM512 213.333333c32.853333 0 59.733333 26.88 59.733333 59.733334v477.866666c0 32.853333-26.88 59.733333-59.733333 59.733334-32.853333 0-59.733333-26.88-59.733333-59.733334V273.066667c0-32.853333 26.88-59.733333 59.733333-59.733334z m238.933333 341.333334c32.853333 0 59.733333 26.88 59.733334 59.733333v136.533333c0 32.853333-26.88 59.733333-59.733334 59.733334-32.853333 0-59.733333-26.88-59.733333-59.733334v-136.533333c0-32.853333 26.88-59.733333 59.733333-59.733333z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.8288e1646be2e01fc539b3e6800b3a7e.svg";
export { ForwardRef as ReactComponent };